module.exports = __webpack_public_path__ + "static/a11ypanel-98ba4ce53b920b7ba965ce910253a0b9.png";